import { render, staticRenderFns } from "./contactView.vue?vue&type=template&id=119f270c&"
import script from "./contactView.vue?vue&type=script&lang=js&"
export * from "./contactView.vue?vue&type=script&lang=js&"
import style0 from "./contactView.vue?vue&type=style&index=0&id=119f270c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports